// Common percentage-fraction conversions for banking exams
export const commonConversions = [
  { fraction: '1/2', percentage: 50, decimal: 0.5 },
  { fraction: '1/3', percentage: 33.33, decimal: 0.3333 },
  { fraction: '1/4', percentage: 25, decimal: 0.25 },
  { fraction: '1/5', percentage: 20, decimal: 0.2 },
  { fraction: '1/6', percentage: 16.67, decimal: 0.1667 },
  { fraction: '1/7', percentage: 14.29, decimal: 0.1429 },
  { fraction: '1/8', percentage: 12.5, decimal: 0.125 },
  { fraction: '1/9', percentage: 11.11, decimal: 0.1111 },
  { fraction: '1/10', percentage: 10, decimal: 0.1 },
  { fraction: '1/12', percentage: 8.33, decimal: 0.0833 },
  { fraction: '2/3', percentage: 66.67, decimal: 0.6667 },
  { fraction: '3/4', percentage: 75, decimal: 0.75 },
  { fraction: '2/5', percentage: 40, decimal: 0.4 },
  { fraction: '3/5', percentage: 60, decimal: 0.6 },
  { fraction: '4/5', percentage: 80, decimal: 0.8 },
  { fraction: '5/6', percentage: 83.33, decimal: 0.8333 },
  { fraction: '3/8', percentage: 37.5, decimal: 0.375 },
  { fraction: '5/8', percentage: 62.5, decimal: 0.625 },
  { fraction: '7/8', percentage: 87.5, decimal: 0.875 },
];

export type ConversionType = 'fraction-to-percentage' | 'percentage-to-fraction';